import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import { useSnackbar } from 'notistack'
import { useEffect } from 'react'

export default function Snackbar() {
  const snackbarMessage = useAppSelector((s) => s.UI.snackbarMessage)
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (snackbarMessage) {
      enqueueSnackbar(snackbarMessage.text, {
        variant: snackbarMessage.type,
      })
      dispatch(UIAction.setSnackbarMessage(undefined))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snackbarMessage])

  return <></>
}
